import { atom } from 'recoil';
import { years } from '../utils/date';

export const yearState = atom({
  key: 'yearState',
  default: years.at(-1),
});

export const authState = atom({
  key: 'authorization_code',
  default: null as string | null,
});

export const isMobileState = atom({
  key: 'isMobile',
  default: false,
});

export const isDarkModeState = atom({
  key: 'isDarkMode',
  default: false,
});
